import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { SubscriptionCreateInput } from '../generated/globalTypes';
import { createSubscriptionMutation, createSubscriptionMutationVariables } from '../generated/createSubscriptionMutation';
import { subscriptionFieldsFragment } from '../models/Subscription';

/**
 * Get a callback to create a Subscription in the store.
 */
export function useCreateSubscriptionCallback(): [(model: SubscriptionCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createSubscriptionMutation, createSubscriptionMutationVariables>(
        gql`
            mutation createSubscriptionMutation ($model: SubscriptionCreateInput!) {
                createSubscription(model: $model) {
                    ...subscriptionFields
                }
            }

            ${subscriptionFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: SubscriptionCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
